import * as React from "react";
import classnames from "classnames";
import { useDrawer } from "../../../../../context/Drawer/context/DrawerContext.js";
/* empty css                  */
const DrawerHeader = ({ LeftSlot, RightSlot, hasBottomBorder }) => {
  const { direction } = useDrawer();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("drawer-header", `drawer-header--${direction}`, {
        "drawer-header--space-between": LeftSlot && RightSlot,
        "drawer-header--has-bottom-border": hasBottomBorder
      })
    },
    LeftSlot && LeftSlot,
    RightSlot && RightSlot
  );
};
export {
  DrawerHeader
};
//# sourceMappingURL=DrawerHeader.js.map
